// You can pass some outer data here
import _ from 'lodash';
import { DEFAULT_ORDER_BY, TAG_TYPE } from '@/constants';

export default () => {
  return [
    {
      prop: 'id',
      label: '编号',
      width: 80
    },
    {
      prop: 'name',
      label: '主题名',
      form: {
        component: 'input',
        required: true
      }
    },
    {
      prop: 'key',
      label: '唯一标识',
    },
    {
      prop: 'first_color_product',
      label: '首个产品',
      width: 200,
      renderCell(h, { row }) {
        const firstColorProduct = _.get(row, 'first_color_product', {})
        return (
          <div class="flex item-center">
            {
              firstColorProduct && (
                <c-router-link to={{ name: 'products.show', params: { id: firstColorProduct.id } }}>
                  <img src={firstColorProduct.cover} style={{ width: '60px', height: '60px', objectFit: 'cover' }} />
                  <el-button type="text" style="width: 190px; text-overflow: ellipsis; overflow: hidden;">{firstColorProduct.name}</el-button>
                </c-router-link>)
            }
          </div>
        )
      }
    },
    {
      prop: 'color_product_num',
      label: '产品数量',
    },
    {
      prop: 'default_order_by',
      label: '产品排序方式',
      width: 120,
      renderCell(h, { row }) {
        return <el-tag type={TAG_TYPE[row.default_order_by]}>{ DEFAULT_ORDER_BY[row.default_order_by] }</el-tag>;
      }
    },
    {
      prop: 'updated_at',
      label: '创建时间',
      renderCell: 'time',
      width: 120,
    },
    {
      prop: 'created_at',
      label: '更新时间',
      action: ['hide-in-table'],
      renderCell: 'time',
      sort: 'order_by'
    }
  ];
}
